<template>
  <ul class="mobile-navigation">
    <!-- For analytics index needs to start with `2` because first item will always be the Soho icon -->
    <NavigationItem
      v-for="(route, index) in routes"
      class="mobile-navigation__item"
      :key="route.link.value.text"
      :hasChildren="isSubNav(route)"
      v-analytics-item="getAnalyticsFields(route, [index + 2])"
    >
      <div
        class="mobile-navigation__item-wrap"
        v-if="isSubNav(route)"
        @click="setActiveItem(VIEWS.MobileSubNav, route, index + 1)"
        @keydown.enter.space="setActiveItem(VIEWS.MobileSubNav, route, index + 1)"
      >
        <span tabindex="0">{{ route.link.value.text }} </span>
        <ShIcon size="xsmall" name="arrowRight" class="mobile-navigation__subnav-icon" :stroke="subMenuArrowStroke" />
      </div>
      <ShLink
        v-else
        :to="route.link.value.href"
        :target="route.link.value.target"
      >
        {{ route.link.value.text }}
      </ShLink>
    </NavigationItem>
    <NavigationItem
      v-if="!currentUser"
      class="mobile-navigation__item mobile-navigation--bottom"
    >
      <sh-button
        :fullWidth="true"
        @click.stop="setActiveItem(VIEWS.MobileSubscription)"
      >
        {{ $t('SUBSCRIBE_TITLE') }}
      </sh-button>
    </NavigationItem>
    <NavigationItem
      v-if="!currentUser"
      class="mobile-navigation__item"
    >
      <ShButton :fullWidth="true" :outline="true" role="link" @click="signIn">
        {{ $t('NAV_SIGN_IN') }}
      </ShButton>
    </NavigationItem>
    <NavigationItem
      :hasChildren="true"
      :class="[
        'mobile-navigation__item',
        'mobile-navigation--bottom-margin',
        { 'mobile-navigation--bottom': currentUser }
      ]"
    >
      <div

        @click="setActiveItem(VIEWS.MobileSubNav, languageRoute)"
        @keydown.enter.space="setActiveItem(VIEWS.MobileSubNav, languageRoute)"
        class="mobile-navigation__item-wrap"
      >
        <span tabindex="0">{{ $t('NAV_LANGUAGE') }}</span>
        <ShIcon size="xsmall" name="arrowRight" class="mobile-navigation__subnav-icon" :stroke="subMenuArrowStroke" />
      </div>
    </NavigationItem>
  </ul>
</template>

<script>
import { createNamespacedHelpers, mapGetters } from 'vuex'
import { NavigationItem, ShIcon } from '@sohohouse/design-system'

import ShLink from '~/components/sh-link'
import { VIEWS } from '~/constants/navbar-views'
import ThemeMixin from '~/mixins/theme'

const { mapState: mapEnvState } = createNamespacedHelpers('ui/environment')

export default {
  name: 'MobileNav',

  components: {
    NavigationItem,
    ShIcon,
    ShLink
  },

  props: {
    routes: {
      type: Array,
      required: true,
      default: () => []
    }
  },

  mixins: [ThemeMixin],

  data () {
    return {
      VIEWS
    }
  },

  computed: {
    ...mapGetters(['currentUser']),
    ...mapEnvState(['languages']),

    languageRoute () {
      const items = this.languages.map(lang => ({
        link: {
          value: {
            text: lang.t,
            code: lang.code,
            target: ''
          }
        }
      }))

      return { link: { value: { text: this.$t('NAV_MOBILE_LANGUAGE_TITLE') } }, items }
    },

    subMenuArrowStroke () {
      return this.isDarkTheme ? 'white' : 'black'
    }
  },

  methods: {
    isSubNav (link) {
      return link.items.length > 0
    },

    setActiveItem (component, link = {}, index) {
      this.$emit('navigation:active', component, link, index)
    },

    signIn () {
      this.$login()
    },

    getAnalyticsFields (route, positions) {
      return this.$analytics.generateNavigationAnalytics(route, positions)
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-navigation {
  margin: 0 $space-060;
  padding: 0;
  min-height: 100%;
  display: flex;
  flex-direction: column;

  &__item {
    margin-bottom: $space-060;

    &-wrap {
      width: 100%;
      display: flex;
    }
  }

  &__subnav-icon {
    margin-left: auto;
    align-self: center;
  }

  &--bottom {
    margin-top: auto;
  }

  &--bottom-margin {
    margin-bottom: $space-110;
  }
}
</style>
